module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Airplay-video-75ba57654f2c90967411ae8975f5b654.svg";